// @generated by protoc-gen-es v2.14.0 with parameter "target=ts,import_extension=none"
// @generated from file errno.proto (package puppy.proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "./google/protobuf/any_pb";
import { file_google_protobuf_any } from "./google/protobuf/any_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file errno.proto.
 */
export const file_errno: GenFile = /*@__PURE__*/
  fileDesc("CgtlcnJuby5wcm90bxIOcHVwcHkucHJvdG8udjEiVwoLRXJyb3JEZXRhaWwSJAoFZXJybm8YASABKA4yFS5wdXBweS5wcm90by52MS5FcnJubxIiCgRkYXRhGAIgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueSqUCgoFRXJybm8SDAoIRVJSTk9fT0sQABITCg9FUlJOT19DQU5DRUxMRUQQARIRCg1FUlJOT19VTktOT1dOEAISGgoWRVJSTk9fSU5WQUxJRF9BUkdVTUVOVBADEhsKF0VSUk5PX0RFQURMSU5FX0VYQ0VFREVEEAQSEwoPRVJSTk9fTk9UX0ZPVU5EEAUSGAoURVJSTk9fQUxSRUFEWV9FWElTVFMQBhIbChdFUlJOT19QRVJNSVNTSU9OX0RFTklFRBAHEhwKGEVSUk5PX1JFU09VUkNFX0VYSEFVU1RFRBAIEh0KGUVSUk5PX0ZBSUxFRF9QUkVDT05ESVRJT04QCRIRCg1FUlJOT19BQk9SVEVEEAoSFgoSRVJSTk9fT1VUX09GX1JBTkdFEAsSFwoTRVJSTk9fVU5JTVBMRU1FTlRFRBAMEhIKDkVSUk5PX0lOVEVSTkFMEA0SFQoRRVJSTk9fVU5BVkFJTEFCTEUQDhITCg9FUlJOT19EQVRBX0xPU1MQDxIZChVFUlJOT19VTkFVVEhFTlRJQ0FURUQQEBIUChBFUlJOT19VTkVYUEVDVEVEEBESEQoNRVJSTk9fVElNRU9VVBASEhsKF0VSUk5PX0RFUEVOREVOQ1lfRkFJTEVEEBMSEgoORVJSTk9fREJfRVJST1IQFBIVChFFUlJOT19DQUNIRV9FUlJPUhAVEhIKDkVSUk5PX01RX0VSUk9SEBYSFQoRRVJSTk9fQkFEX0dBVEVXQVkQFxIWChJFUlJOT19SQVRFX0xJTUlURUQQGBIYChRFUlJOT19RVU9UQV9FWENFRURFRBAZEh0KGUVSUk5PX1NFUlZJQ0VfTUFJTlRFTkFOQ0UQGhIXChNFUlJOT19OT1RfU1VQUE9SVEVEEBsSFgoSRVJSTk9fQ09ORklHX0VSUk9SEBwSHgoaRVJSTk9fQVVUSE9SSVpBVElPTl9GQUlMRUQQHRIbChdFUlJOT19TSUdOQVRVUkVfSU5WQUxJRBAeEhcKEkVSUk5PXzJGQV9SRVFVSVJFRBDJARIZChRFUlJOT19VU0VSX05PVF9GT1VORBDKARIgChtFUlJOT19VU0VSX1BBU1NXT1JEX0lOVkFMSUQQywESHQoYRVJSTk9fQVVUSF9UT0tFTl9FWFBJUkVEEMwBEhkKFEVSUk5PX0ZJTEVfVE9PX0xBUkdFEM0BEhkKFEVSUk5PX0ZJTEVfTk9UX0ZPVU5EEM4BEhsKFkVSUk5PX1BBWU1FTlRfUkVRVUlSRUQQzwESGQoURVJSTk9fQUNDT1VOVF9MT0NLRUQQ0AESHAoXRVJSTk9fQUNDT1VOVF9TVVNQRU5ERUQQ0QESHwoaRVJSTk9fRU1BSUxfQUxSRUFEWV9FWElTVFMQ0gESGQoURVJSTk9fVVNFUk5BTUVfVEFLRU4Q0wESGwoWRVJSTk9fQ0FQVENIQV9SRVFVSVJFRBDUARIaChVFUlJOT19DQVBUQ0hBX0lOVkFMSUQQ1QESHgoZRVJSTk9fUkFURV9MSU1JVF9FWENFRURFRBDWARIZChRFUlJOT19QQVlNRU5UX0ZBSUxFRBDXARIdChhFUlJOT19JTlNVRkZJQ0lFTlRfRlVORFMQ2AESIwoeRVJSTk9fUEFTU1dPUkRfQ0hBTkdFX1JFUVVJUkVEENkBEh0KGEVSUk5PXzJGQV9TRVRVUF9SRVFVSVJFRBDaASIFCGQQxwFiBnByb3RvMw", [file_google_protobuf_any]);

/**
 * 可复用的错误消息结构
 *
 * @generated from message puppy.proto.v1.ErrorDetail
 */
export type ErrorDetail = Message<"puppy.proto.v1.ErrorDetail"> & {
  /**
   * Errno（包含 gRPC codes 的映射（0-16）以及自定义扩展值）
   *
   * @generated from field: puppy.proto.v1.Errno errno = 1;
   */
  errno: Errno;

  /**
   * 结构化错误详情（可选），由具体业务自行定义并 Any 包装
   *
   * @generated from field: google.protobuf.Any data = 2;
   */
  data?: Any | undefined;
};

/**
 * Describes the message puppy.proto.v1.ErrorDetail.
 * Use `create(ErrorDetailSchema)` to create a new message.
 */
export const ErrorDetailSchema: GenMessage<ErrorDetail> = /*@__PURE__*/
  messageDesc(file_errno, 0);

/**
 * @generated from enum puppy.proto.v1.Errno
 */
export enum Errno {
  /**
   * ---------------------------------------------------
   * 与 gRPC status code 对齐（数值兼容 google.rpc.Code，0-16）
   * ---------------------------------------------------
   *
   * OK - 操作成功
   *
   * @generated from enum value: ERRNO_OK = 0;
   */
  ERRNO_OK = 0,

  /**
   * CANCELLED
   *
   * @generated from enum value: ERRNO_CANCELLED = 1;
   */
  ERRNO_CANCELLED = 1,

  /**
   * UNKNOWN
   *
   * @generated from enum value: ERRNO_UNKNOWN = 2;
   */
  ERRNO_UNKNOWN = 2,

  /**
   * INVALID_ARGUMENT
   *
   * @generated from enum value: ERRNO_INVALID_ARGUMENT = 3;
   */
  ERRNO_INVALID_ARGUMENT = 3,

  /**
   * DEADLINE_EXCEEDED
   *
   * @generated from enum value: ERRNO_DEADLINE_EXCEEDED = 4;
   */
  ERRNO_DEADLINE_EXCEEDED = 4,

  /**
   * NOT_FOUND
   *
   * @generated from enum value: ERRNO_NOT_FOUND = 5;
   */
  ERRNO_NOT_FOUND = 5,

  /**
   * ALREADY_EXISTS
   *
   * @generated from enum value: ERRNO_ALREADY_EXISTS = 6;
   */
  ERRNO_ALREADY_EXISTS = 6,

  /**
   * PERMISSION_DENIED
   *
   * @generated from enum value: ERRNO_PERMISSION_DENIED = 7;
   */
  ERRNO_PERMISSION_DENIED = 7,

  /**
   * RESOURCE_EXHAUSTED
   *
   * @generated from enum value: ERRNO_RESOURCE_EXHAUSTED = 8;
   */
  ERRNO_RESOURCE_EXHAUSTED = 8,

  /**
   * FAILED_PRECONDITION
   *
   * @generated from enum value: ERRNO_FAILED_PRECONDITION = 9;
   */
  ERRNO_FAILED_PRECONDITION = 9,

  /**
   * ABORTED
   *
   * @generated from enum value: ERRNO_ABORTED = 10;
   */
  ERRNO_ABORTED = 10,

  /**
   * OUT_OF_RANGE
   *
   * @generated from enum value: ERRNO_OUT_OF_RANGE = 11;
   */
  ERRNO_OUT_OF_RANGE = 11,

  /**
   * UNIMPLEMENTED
   *
   * @generated from enum value: ERRNO_UNIMPLEMENTED = 12;
   */
  ERRNO_UNIMPLEMENTED = 12,

  /**
   * INTERNAL
   *
   * @generated from enum value: ERRNO_INTERNAL = 13;
   */
  ERRNO_INTERNAL = 13,

  /**
   * UNAVAILABLE
   *
   * @generated from enum value: ERRNO_UNAVAILABLE = 14;
   */
  ERRNO_UNAVAILABLE = 14,

  /**
   * DATA_LOSS
   *
   * @generated from enum value: ERRNO_DATA_LOSS = 15;
   */
  ERRNO_DATA_LOSS = 15,

  /**
   * UNAUTHENTICATED
   *
   * @generated from enum value: ERRNO_UNAUTHENTICATED = 16;
   */
  ERRNO_UNAUTHENTICATED = 16,

  /**
   * ---------------------------------------------------
   * 服务/内部扩展（17-99）
   * ---------------------------------------------------
   *
   * 非预期错误（兜底）
   *
   * @generated from enum value: ERRNO_UNEXPECTED = 17;
   */
  ERRNO_UNEXPECTED = 17,

  /**
   * 操作超时（通常映射到 DEADLINE_EXCEEDED）
   *
   * @generated from enum value: ERRNO_TIMEOUT = 18;
   */
  ERRNO_TIMEOUT = 18,

  /**
   * 依赖系统失败（第三方/下游服务）
   *
   * @generated from enum value: ERRNO_DEPENDENCY_FAILED = 19;
   */
  ERRNO_DEPENDENCY_FAILED = 19,

  /**
   * 数据库操作错误
   *
   * @generated from enum value: ERRNO_DB_ERROR = 20;
   */
  ERRNO_DB_ERROR = 20,

  /**
   * 缓存系统错误
   *
   * @generated from enum value: ERRNO_CACHE_ERROR = 21;
   */
  ERRNO_CACHE_ERROR = 21,

  /**
   * 消息队列错误
   *
   * @generated from enum value: ERRNO_MQ_ERROR = 22;
   */
  ERRNO_MQ_ERROR = 22,

  /**
   * 下游网关错误（HTTP 502）
   *
   * @generated from enum value: ERRNO_BAD_GATEWAY = 23;
   */
  ERRNO_BAD_GATEWAY = 23,

  /**
   * 速率限制
   *
   * @generated from enum value: ERRNO_RATE_LIMITED = 24;
   */
  ERRNO_RATE_LIMITED = 24,

  /**
   * 配额超出
   *
   * @generated from enum value: ERRNO_QUOTA_EXCEEDED = 25;
   */
  ERRNO_QUOTA_EXCEEDED = 25,

  /**
   * 服务维护中
   *
   * @generated from enum value: ERRNO_SERVICE_MAINTENANCE = 26;
   */
  ERRNO_SERVICE_MAINTENANCE = 26,

  /**
   * 功能不支持
   *
   * @generated from enum value: ERRNO_NOT_SUPPORTED = 27;
   */
  ERRNO_NOT_SUPPORTED = 27,

  /**
   * 配置错误
   *
   * @generated from enum value: ERRNO_CONFIG_ERROR = 28;
   */
  ERRNO_CONFIG_ERROR = 28,

  /**
   * 授权失败
   *
   * @generated from enum value: ERRNO_AUTHORIZATION_FAILED = 29;
   */
  ERRNO_AUTHORIZATION_FAILED = 29,

  /**
   * 签名无效
   *
   * @generated from enum value: ERRNO_SIGNATURE_INVALID = 30;
   */
  ERRNO_SIGNATURE_INVALID = 30,

  /**
   * ---------------------------------------------------
   * 业务错误（建议从 200 开始分配）
   * ---------------------------------------------------
   *
   * 需要双因子验证（Two-Factor Authentication required）
   *
   * @generated from enum value: ERRNO_2FA_REQUIRED = 201;
   */
  ERRNO_2FA_REQUIRED = 201,

  /**
   * 用户不存在
   *
   * @generated from enum value: ERRNO_USER_NOT_FOUND = 202;
   */
  ERRNO_USER_NOT_FOUND = 202,

  /**
   * 密码或凭证无效
   *
   * @generated from enum value: ERRNO_USER_PASSWORD_INVALID = 203;
   */
  ERRNO_USER_PASSWORD_INVALID = 203,

  /**
   * 令牌已过期
   *
   * @generated from enum value: ERRNO_AUTH_TOKEN_EXPIRED = 204;
   */
  ERRNO_AUTH_TOKEN_EXPIRED = 204,

  /**
   * 上传文件过大
   *
   * @generated from enum value: ERRNO_FILE_TOO_LARGE = 205;
   */
  ERRNO_FILE_TOO_LARGE = 205,

  /**
   * 文件未找到
   *
   * @generated from enum value: ERRNO_FILE_NOT_FOUND = 206;
   */
  ERRNO_FILE_NOT_FOUND = 206,

  /**
   * 需要支付
   *
   * @generated from enum value: ERRNO_PAYMENT_REQUIRED = 207;
   */
  ERRNO_PAYMENT_REQUIRED = 207,

  /**
   * 账户/验证/限流等常见业务码
   *
   * 账户被锁定
   *
   * @generated from enum value: ERRNO_ACCOUNT_LOCKED = 208;
   */
  ERRNO_ACCOUNT_LOCKED = 208,

  /**
   * 账户被暂停
   *
   * @generated from enum value: ERRNO_ACCOUNT_SUSPENDED = 209;
   */
  ERRNO_ACCOUNT_SUSPENDED = 209,

  /**
   * 邮箱已被注册
   *
   * @generated from enum value: ERRNO_EMAIL_ALREADY_EXISTS = 210;
   */
  ERRNO_EMAIL_ALREADY_EXISTS = 210,

  /**
   * 用户名已被占用
   *
   * @generated from enum value: ERRNO_USERNAME_TAKEN = 211;
   */
  ERRNO_USERNAME_TAKEN = 211,

  /**
   * 需要验证码
   *
   * @generated from enum value: ERRNO_CAPTCHA_REQUIRED = 212;
   */
  ERRNO_CAPTCHA_REQUIRED = 212,

  /**
   * 验证码无效
   *
   * @generated from enum value: ERRNO_CAPTCHA_INVALID = 213;
   */
  ERRNO_CAPTCHA_INVALID = 213,

  /**
   * 超过速率限制
   *
   * @generated from enum value: ERRNO_RATE_LIMIT_EXCEEDED = 214;
   */
  ERRNO_RATE_LIMIT_EXCEEDED = 214,

  /**
   * 支付失败
   *
   * @generated from enum value: ERRNO_PAYMENT_FAILED = 215;
   */
  ERRNO_PAYMENT_FAILED = 215,

  /**
   * 余额不足
   *
   * @generated from enum value: ERRNO_INSUFFICIENT_FUNDS = 216;
   */
  ERRNO_INSUFFICIENT_FUNDS = 216,

  /**
   * 必须修改密码（例如首次登录/管理员强制）
   *
   * @generated from enum value: ERRNO_PASSWORD_CHANGE_REQUIRED = 217;
   */
  ERRNO_PASSWORD_CHANGE_REQUIRED = 217,

  /**
   * 需要先启用/绑定双因子验证（2FA setup required）
   *
   * @generated from enum value: ERRNO_2FA_SETUP_REQUIRED = 218;
   */
  ERRNO_2FA_SETUP_REQUIRED = 218,
}

/**
 * Describes the enum puppy.proto.v1.Errno.
 */
export const ErrnoSchema: GenEnum<Errno> = /*@__PURE__*/
  enumDesc(file_errno, 0);

